export default __webpack_public_path__ + "media/images/react_icons/casatb/close_gray-f50639ab8f2c2ab6c8479dd5c2aa4ba0.svg";